const STORAGE_KEY = "pendingPosSold";

export interface PendingPosSold {
  storeId: string;
  businessDate: string;
  failedAt: string;
}

/**
 * เก็บรายการวันที่ "ปิดร้านแล้วแต่ยิงคำนวณสต็อกไม่สำเร็จ" ไว้ใน localStorage
 *
 * ที่ต้องมีเพราะ: ถ้าเน็ตหลุดตอนปิดร้าน POS จะยิง /inventories-tx/pos-sold ไม่สำเร็จ
 * ทำให้ businessDate นั้นไม่มี transaction 'pos-closed' และสต็อกไม่ถูกตัดเลยทั้งวัน
 * โดยไม่มีใครรู้ (เคสร้าน charter วันที่ 2026-08-14)
 *
 * ตอนเปิดร้านวันใหม่จะเอา list นี้มายิงซ้ำให้
 * ยิงซ้ำปลอดภัย เพราะ transaction ใช้ key `${businessDate}:pos-closed` เป็นการเขียนทับ
 */
export const usePendingPosSold = () => {
  function read(): PendingPosSold[] {
    if (typeof window === "undefined") return [];
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.error("usePendingPosSold: read failed", error);
      return [];
    }
  }

  function write(list: PendingPosSold[]) {
    if (typeof window === "undefined") return;
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (error) {
      console.error("usePendingPosSold: write failed", error);
    }
  }

  function add(payload: { storeId: string; businessDate: string }) {
    const list = read().filter((p) => p.businessDate !== payload.businessDate);
    list.push({
      storeId: payload.storeId,
      businessDate: payload.businessDate,
      failedAt: new Date().toISOString(),
    });
    write(list);
  }

  function clear(businessDate: string) {
    write(read().filter((p) => p.businessDate !== businessDate));
  }

  function clearAll() {
    write([]);
  }

  return { read, add, clear, clearAll };
};
